import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import "core-js";
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { currentEnv, isMaintenanceTime } from "./config/config";
import Outage from "./revampPages/Outage";
import * as Sentry from "@sentry/react";
import { SequenceNumberProvider } from "./contexts/SequenceNumberContext";

if (currentEnv === "staging" || currentEnv === "prod") {
    Sentry.init({
        dsn: "https://e486677cbc950ba4404332783c5dbe49@o4508326426181632.ingest.de.sentry.io/4508496551411792",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: currentEnv === "prod" ? 1.0 : 0.05,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: currentEnv,
        ignoreErrors: [
            // Browser extension errors
            /chrome-extension:/,
            /ExtensionsBundleLoader/,
            /extensions::/,
            // Network/library errors
            /Network Error/,
            /ETIMEDOUT/,
            /ECONNABORTED/,
            / AxiosError /,
            /fetch failed/,
            // General node_modules paths
            /node_modules/,
        ],
        beforeSend(event) {
            if (window.location.hostname === "localhost") return null; // drop dev noise
            if (isNodeModulesError(event)) return null;

            // Kill /monitoring requests silently
            const url = event.request?.url || event.transaction || "";
            if (typeof url === "string" && url.includes("/monitoring")) return null;

            return event;
        },
    });
}

function isNodeModulesError(event) {
    if (!event.exception?.values) return false;

    for (const exception of event.exception.values) {
        const frames = exception.stacktrace?.frames || [];
        const hasNodeModules = frames.some((frame) => {
            const filename = frame.filename || "";
            const absPath = frame.abs_path || "";
            return (
                filename.includes("node_modules") ||
                absPath.includes("node_modules") ||
                /webpack:\/\/\/\.\/node_modules\//.test(absPath) ||
                absPath.includes("webpack:///./node_modules/") ||
                absPath.includes("~")
            );
        });
        if (hasNodeModules) return true;
    }

    return false;
}

ReactDOM.render(
    <Provider store={store}>
        <Sentry.ErrorBoundary>
            <SequenceNumberProvider>
                {isMaintenanceTime ?
                    <Outage />
                    :
                    <App />
                }
            </SequenceNumberProvider>
        </Sentry.ErrorBoundary>
    </Provider>,
    document.getElementById("root")
);
serviceWorker.unregister();
reportWebVitals();
